import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
  DialogFooter,
} from '../../ui/dialog';
import { Button } from '../../ui/button';
import { RadioGroup, RadioGroupItem } from '../../ui/radio-group';
import { Label } from '../../ui/label';
import { ArrowLeft } from 'lucide-react';

interface SpecifyTaxDocumentTypeDialogProps {
  isOpen: boolean;
  onClose: () => void;
  onBack: () => void;
  onConfirm: (type: string) => void;
}

const taxDocumentTypes = ['TPS_TVQ', 'T4_SLIPS', 'R1_SLIPS', 'OTHER'];

export const SpecifyTaxDocumentTypeDialog: React.FC<SpecifyTaxDocumentTypeDialogProps> = ({
  isOpen,
  onClose,
  onBack,
  onConfirm,
}) => {
  const [selectedType, setSelectedType] = useState<string | null>(null);
  const { t } = useTranslation();

  const handleConfirm = () => {
    if (selectedType) {
      onConfirm(selectedType);
      resetAndClose();
    }
  };

  const resetAndClose = () => {
    setSelectedType(null);
    onClose();
  };

  return (
    <Dialog open={isOpen} onOpenChange={resetAndClose}>
      <DialogContent className="sm:max-w-[425px]">
        <DialogHeader>
          <DialogTitle className="flex items-center">
            <button onClick={onBack} className="mr-2 p-1 rounded-full hover:bg-accent">
              <ArrowLeft className="h-4 w-4" />
            </button>
            {t('dialog.chooseDocType')}
          </DialogTitle>
          <DialogDescription>{t('dialog.chooseMainCategory')}</DialogDescription>
        </DialogHeader>
        <div className="grid gap-4 py-4">
          <RadioGroup value={selectedType || ''} onValueChange={setSelectedType}>
            {taxDocumentTypes.map((type) => (
              <div key={type} className="flex items-center space-x-2">
                <RadioGroupItem value={type} id={type} />
                <Label htmlFor={type}>{t(`docType.${type}`)}</Label>
              </div>
            ))}
          </RadioGroup>
        </div>
        <DialogFooter>
          <Button variant="outline" onClick={resetAndClose}>
            {t('actions.cancel')}
          </Button>
          <Button onClick={handleConfirm} disabled={!selectedType}>
            {t('actions.validate')}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
